import { useEffect } from "react";
import { SEO_BASE, DEFAULT_OG_IMAGE } from "../config/brand";

export { SEO_BASE, DEFAULT_OG_IMAGE };

const upsertMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Lightweight, dependency-free per-page SEO head manager.
export function useSeo({ title, description, path, jsonLd, image }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    const ogImage = image || DEFAULT_OG_IMAGE;
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:image", ogImage);
    if (path != null) {
      const canonical = SEO_BASE + path;
      upsertLink("canonical", canonical);
      upsertMeta("property", "og:url", canonical);
    }

    const id = "page-jsonld";
    let s = document.getElementById(id);
    if (jsonLd) {
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = id;
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    } else if (s) {
      s.remove();
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [title, description, path, image, JSON.stringify(jsonLd)]);
}
